import type { DesktopProcessActions } from '@common/enums/desktopProcessActions';
import type { ServiceCode } from '@common/enums/serviceCode';
import type { IHolterDesktopProcess } from '@frontend/components/interfaces/holterDesktopProcess';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/desktopProcesses';

export async function getDesktopProcessIdAndUrl(processActivityId: string): Promise<{ id: string; url: string }> {
    const result = await fetchJson({
        body: {
            processActivityId,
        },
        method: 'POST',
        url: `${baseUrl}/startHolter`,
    });

    return result.json;
}

export async function getDesktopProcess(desktopProcessId: string, signal: AbortSignal): Promise<IHolterDesktopProcess> {
    const result = await fetchJson({
        method: 'GET',
        signal,
        url: `${baseUrl}/${desktopProcessId}`,
    });

    return result.json;
}

export async function createDesktopProcess(args: {
    action: DesktopProcessActions;
    params: { [key: string]: string | undefined };
    processActivityId?: string | null;
    requestId?: string | null;
    serviceCode: ServiceCode;
    signal: AbortSignal;
}) {
    const { action, params, processActivityId, requestId, serviceCode, signal } = args;
    const url = baseUrl;
    const body = {
        action,
        params,
        processActivityId,
        requestId,
        serviceCode,
    };
    const result = await fetchJson({ body, method: 'POST', signal, url });

    return result.json;
}
